import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ForumsService } from 'src/app/services/forums.service';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-show',
  templateUrl: './show.component.html',
  styleUrl: './show.component.scss'
})
export class ShowComponent {

  public slug: string;
  public forum: any = {};
  public lang = this.languageService.getLanguage();
  public loading: boolean = false;
  public formMainComment: FormGroup;
  constructor(
    private languageService: LanguageService,
    private route: ActivatedRoute,
    private forumsService: ForumsService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) { 
    this.route.params.subscribe(params => {
      this.slug = params['id'];
    });

    this.formMainComment = this.fb.group({
      text: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.getResource();
  }

  getResource() {
    this.loading = true;
    this.forumsService.getResource(this.slug).subscribe({
      next: response => {
        this.forum = response;
        this.loading = false;
      },
      complete: () => {},
      error: error => {
        console.log("GetResourceError: ", error);
        this.loading = false;
      }
    });
  }

  saveMainComment() {
    if (this.formMainComment.valid) {
      this.loading = true;
      this.forumsService.addComment(this.slug, this.formMainComment.value).subscribe({
        next: response => {
          this.forum.comments.push(response);
          this.loading = false;
          this.formMainComment.reset();
        },
        complete: () => {},
        error: error => {
          this.loading = false;
          console.log("SaveMainCommentError: ", error);
          this.toastr.error($localize`:@@error:Error al guardar el comentario`);
        }
      });
    } else {
      console.log("FormMainCommentInvalid: ", this.formMainComment);
    }
  }

  destroyComment(commentId: number) {
    
    if (!confirm($localize`:@@confirm:¿Estás seguro de eliminar este comentario?`)) {
      return;
    }

    this.loading = true;

    this.forumsService.destroyComment(commentId).subscribe({
      next: response => {
        this.forum.comments = this.forum.comments.filter((comment: any) => comment.id !== commentId);
        this.loading = false;
      },
      complete: () => {},
      error: error => {
        this.loading = false;
        console.log("DestroyCommentError: ", error);
        this.toastr.error($localize`:@@error:Error al eliminar el comentario`);
      }
    });
  }

  destroyResource() {
    if (!confirm($localize`:@@confirm:¿Estás seguro de eliminar este recurso?`)) {
      return;
    }

    this.loading = true;

    this.forumsService.destroyResource(this.slug).subscribe({
      next: response => {
        this.loading = false;
        window.location.href = '/platform/forum';
      },
      complete: () => {},
      error: error => {
        this.loading = false;
        this.toastr.error($localize`:@@error:Error al eliminar el recurso`);
      }
    });
  }

  toggleLike() {
    if (this.forum.liked_by_current_user) {
      if (!this.forum.forum_unlike_path) {
        return;
      }
      this.forum.liked_by_current_user = false;
      this.forum.likes_count -= 1;
      this.forumsService.dislikeResource(this.forum.forum_unlike_path).subscribe({
        next: response => {
        },
        complete: () => {},
        error: error => {
          this.forum.liked_by_current_user = true;
          this.forum.likes_count += 1;
          this.toastr.error('Error al quitar like al recurso');
          console.log("UnlikeResourceError: ", error);
        }
      });
    }  else {
      this.forum.liked_by_current_user = true;
      this.forum.likes_count += 1;
      this.forumsService.likeResource(this.forum.forum_like_path).subscribe({
        next: response => {
          this.forum.forum_unlike_path = response.forum_unlike_path;
        },
        complete: () => {},
        error: error => {
          this.toastr.error('Error al dar like al recurso');
          console.log("LikeResourceError: ", error);
        }
      });
    }
  }
}
